import { create } from 'zustand'

type Store = {
    loginSucceeded: boolean,
    setLoginSucceeded: (value: boolean) => void,
    token: string,
    setToken: (name: string) => void,
    tenantName: string,
    setTenantName: (name: string) => void,
    tenant: string,
    setTenant: (name: string) => void,
    tenantUserEmail: string,
    setTenantUserEmail: (name: string) => void,
};

export const useStore = create<Store>((set) => ({
    loginSucceeded: false,
    setLoginSucceeded: (value: boolean) => set((state) => ({ loginSucceeded: value })),
    token: "",
    setToken: (name: string) => set((state) => ({ token: name })),
    tenantName: "",
    setTenantName: (name: string) => set((state) => ({ tenantName: name })),
    tenant: "",
    setTenant: (name: string) => set((state) => ({ tenant: name })),
    tenantUserEmail: "",
    setTenantUserEmail: (name: string) => set((state) => ({ tenantUserEmail: name })),
}));